<template>
  <page>
    <head-nav title="language.page_settings">
      <icon-button-home v-on:click.native.stop.prevent="saveSettings()" :overrideClick="true" slot="right"></icon-button-home>
    </head-nav>
  <scroll-page>
   
    <page-padding>
    <fold-button title="language.lang_choice">
      <ui-radio-group :val="user_stored.language" @input="setLanguage">
        <div>
          <ui-radio class="custom-radio" val="nl" :selected="(user_stored.language=='nl')">
            Nederlands
          </ui-radio>
        </div>
        <div>
          <ui-radio class="custom-radio" val="en" :selected="(user_stored.language=='en')">
           English
          </ui-radio>
        </div>
        <div>
          <ui-radio class="custom-radio" val="it" :selected="(user_stored.language=='it')">
            Italiano
          </ui-radio>
        </div>
      </ui-radio-group>
    </fold-button>

    <fold-button title="language.add_school">
      <ui-input title="language.provide_url" type="url" autocapitalize="none"  v-bind:val="url" @input="(v)=>{url = v}">
        <div class="www" slot="left">www.</div>
      </ui-input>
      <ui-input title="language.provide_email" type="email" autocapitalize="none"  v-bind:val="username" @input="(v)=>{username = v}"></ui-input>
      <ui-input title="language.provide_password" :type="computePaswordInputType" autocapitalize="none" v-bind:val="password" @input="(v)=>{password = v}">
        <div slot="icons"><font-awesome-icon class="icon" @click="togglePasswordShow()" :icon="computeEyeIcon" /></div>
      </ui-input>
      <button-activate :active="button_active" v-on:click.native="addNewSchool" title="language.add_new_school_button"></button-activate>
    </fold-button>
    
    <my-schools/>

    <fold-button title="language.profile_picture">
      <div class="avatar-container" >
        
        <span class="avatar-span">
          <avatar :src="computeAvatarScr" :style="computeAvatarRotation"/>
          <ui-icon v-if="computeRemoveIcon" @click.native="removeAvatar()" class="remove-avatar" icon="times"/>
        </span>
        <!--
        <div class="avatar-bg-image" :style="computeAvatarRotation">
          <img @error="avatarLoadError" @load="avatarLoaded" :src="computeAvatarScr">
        </div>
        -->
        
      </div>

      <button-action v-if="isMobile" v-on:click.native="getCameraImage()" title="language.camera" ></button-action>
      <button-action v-if="isMobile" v-on:click.native="getGalleryImage()" title="language.gallery" ></button-action>

      <!-- pick images desktop variant -->
      <button-file v-if="!isMobile" :multiple="false" accept="image/jpeg,image/png" title="language.gallery" @change="getGalleryImageBrowser"></button-file>

    </fold-button>

    <!--:class="{'disabled-fold':!loggedIn }"-->
    <fold-button v-if="computeShowPushchecks"  title="language.other_settings_button">
       <ui-check :val="push_all" @click.native='clickedPushPref("all")' @selected="(v)=>{push_all=v}" title="language.user_get_all_pushnotes" />
      <ui-check :val="push_group" @click.native='clickedPushPref("group")' @selected="(v)=>{push_group=v}" title="language.user_get_important_pushnotes" />
    </fold-button>


    <div v-if="debug">
      <button v-on:click="clearUserSettingss()">debug::clear user settings</button>
      <button v-on:click="addTestSchools()">debug::add test schools</button>
      <div> push subscription: {{  computeSubscription }}</div>

    </div>
    
    
    <div>app version: {{app_version}}</div>
    <div>db: {{database}}</div>
    
    </page-padding>
  

    </scroll-page>
   </page>
</template>

<script>

import pushManager from '../services/PushManager.js'
import Page from './Page';
import MySchools from '../components/MySchools';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import FoldButton from '../components/buttons/FoldButton.vue';
import UiRadio from '../components/UiRadio.vue';
import UiCheck from '../components/UiCheck.vue';
import UiRadioGroup from '../components/UiRadioGroup.vue';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import PagePadding from '../components/PagePadding.vue';
import UiInput from '../components/UiInput.vue';
import UiIcon from '../components/UiIcon.vue';
import ScrollPage from '../components/ScrollPage.vue';
import Avatar from '../components/Avatar.vue';
import Vue from 'vue';
import { eventBus } from '../services/EventBus.js';
import { mapState } from 'vuex'
import { imagePicker } from '../services/ImagePicker.js'
import { cordovaInit } from '../services/CordovaInit.js';
import ButtonFile from '../components/buttons/ButtonFile.vue';
import { storageService } from '../services/StorageService.js';
import { SETTINGS } from '../SETTINGS.js';

export default {
  name: 'SettingsPage',
  created(){
  },
  data:function(){
    return{
      url:"",
      bgUrl:"",
      username:"",
      password:"",
      temp_avatar_media:{url:"",exiforientation:0},
      app_version:SETTINGS.version,
      push_all:true,
      push_group:false,
      show_password:false,
      button_active:true,
      isMobile:cordovaInit.isMobile(),
      database:storageService.provider.name,
    }
    
  },
  
  beforeDestroy(){
    eventBus.$off('saveSettings',this.saveSettings);
  },
  mounted(){

     eventBus.$on('saveSettings',this.saveSettings);

    // if logged in this will load from appSettings
      if(this.loggedIn){
        this.loadPushConfigForCurrentLogin();
      }
     

     // leave code out of production build
     if(process.env.NODE_ENV === "development") {
       
        this.url="fred.schoolsunited.eu"
        this.username="user_3@gmail.com"
        this.password="test"
       
     }
     
    
  },
  computed:{
     ...mapState([
       'appSettings','user_stored','loggedIn','debug',
       ]),
       computeSubscription(){
        return JSON.stringify(pushManager.subscription);
       },
       computeShowPushchecks(){
         // we are not on mobile, we dont receive any pushes in the browser...
         
        return this.loggedIn;
       },
       computeEyeIcon(){
         if(this.show_password){
           return 'eye-slash'
         }else{
           return 'eye'
         }
       },
       computePaswordInputType(){
         if(this.show_password){
           return 'text'
         }else{
           return 'password'
         }
       },
       computeAvatarScr(){
         // prefer local avatar before appSettings
         var timestamp="?ts="+new Date().getTime();
         return this.temp_avatar_media.url ? this.temp_avatar_media.url: this.appSettings.avatar+timestamp;
       },
       computeRemoveIcon(){
         if(!this.temp_avatar_media.url && !this.appSettings.avatar){
           return false;
         }
         return true;
       },
        computeAvatarRotation(){
          // rotates temporary avatar it is rotated
          if(this.temp_avatar_media.url){
        
            var r=0;
            var exifOrientation = this.temp_avatar_media.exifOrientation;
            
            switch(exifOrientation){
              case 1: r=0; break;
              case 8: r=-90; break;
              case 3: r=180; break;
              case 6: r=90; break;
              default: r=0; break;
            }
         
            return {transform:'rotate('+r+'deg)'}


         }else{
            return {}
         }

        },
        
      
  },
  components: {
    Page,
    MySchools,
    HeadNav,
    IconButtonHome,
    FoldButton,
    UiRadio,
    UiRadioGroup,
    UiCheck,
    PagePadding,
    UiInput,
    ButtonActivate,
    ButtonAction,
    ScrollPage,
    Avatar,
    ButtonFile,
    UiIcon,
  },
  methods:{
    saveSettings(){
     
     var promises=[];
    var payload;

     // save pushnotes for app to api
      payload={
        push_all:this.push_all ? 1 : 0 ,
        push_group:this.push_group ? 1 : 0,
      }
      promises.push(this.$store.dispatch('set_push_config',payload));


      // save avatar to api
      
      if(this.temp_avatar_media.url){
      
        payload={
            exif_orientation:this.temp_avatar_media.exifOrientation,
            avatar:this.temp_avatar_media.url,
        }
        promises.push(this.$store.dispatch('add_avatar',payload));
       
      }

      // if all saved now safely go home
      Promise.all(promises).then(()=>{
        
        this.temp_avatar_media.url="";
        this.goHome();
       
        
      });

    },
    removeAvatar(){


      this.$store.dispatch('remove_avatar',{}).then(()=>{
        this.temp_avatar_media.url="";
      })
     
    },
    goHome(){
      
      this.$router.push({path:'/'})
    },
    togglePasswordShow(){
      this.show_password=!this.show_password;
    },
    clickedPushPref(pref){
     
      switch(pref){
        case "all":
          if(this.push_all){
            this.push_group=false;
          }
          
        break;
        case "group":
          if(this.push_group){
            this.push_all=false;
          }
        break;
      }
      
     
      
    },
    //after_login from myschool
    loadPushConfigForCurrentLogin(){
      
      if(this.appSettings){
        if(this.appSettings.push_config){
          this.push_all = (this.appSettings.push_config.push_all=="1") ? true : false;
          this.push_group = (this.appSettings.push_config.push_group=="1") ? true : false;
        }else{
          if(this.loggedIn){
            Vue.$toaster.toast("[error]: appSettings.push_config is not defined for this user")
          }
        }
      }



    },
    addTestSchools(){
      this.$store.dispatch('addTestSchools');
    },
    setLanguage(val){
      // setting current locale
      this.$i18n.locale = val;
      this.storeUserSetting("language",val)
    },
    storeUserSetting(key,val){
      // saves user setting to state and websql in store
      var payload={
        key:key,
        val:val
      }
  
      this.$store.dispatch('store_user_setting',payload);
    },
    addNewSchool(){
      if (this.url==="" || this.username==="" || this.password===""){return;}

      this.button_active=false;

      // remove protocols from url
      this.url = this.url.replace(/(^\w+:|^)\/\//, '');
      var school={
        url:this.url,
        username:this.username,
        password:this.password,
        active:0,
        protocol:"https://",
      }
      
      this.$store.dispatch('addSchool',{ school, router:this.$router}).then(
        ()=>{
          
          this.button_active=true;
          // at this moment we shouyld be logged in,
          this.saveSettings();
          },
        ()=>{ 
          this.button_active=true;
          }
      )
      

    },
    clearUserSettingss(){
      this.$store.dispatch('clearUserSettings');
    },
    getCameraImage(){

      var args={
          allowEdit : false,
          targetWidth: 1920,
          targetHeight: 1920,
          quality: 70,
          mediaType: window.Camera ? window.Camera.MediaType.PICTURE : undefined,
          correctOrientation:true,
        };
      imagePicker.getCamera(args).then(media=>{
         this.setTempAvatar(media)
      })
    },
    getGalleryImage(){
      var args = {
        selectMode: imagePicker.mediaType.IMAGE, //101=picker image and video , 100=image , 102=video
        maxSelectCount: 1, //default 40 (Optional)
        maxSelectSize: 15000000, //(Optional) only android (15 mb max)
      };

      imagePicker.getMedias(args).then( medias => {
          // set temporary avatar 
          this.setTempAvatar(medias[0])
      });
    },
    getGalleryImageBrowser(e){
      
      this.buttonActive=false;
      imagePicker.fileListToMedias(e.target.files).then(medias=>{
       
        this.setTempAvatar(medias[0]);
        this.buttonActive=true;
      })

    },
    async setTempAvatar(media){
      
      
      if(imagePicker.isBase64(media.url)){
        // must be dummy no need to resize
         this.temp_avatar_media=media;
      }else{
        // convert media.url to base64
        await imagePicker.resizeUrlToBase64(media.url,400).then(base64Result=>{
          this.temp_avatar_media={
            url:base64Result,
            exifOrientation:media.exifOrientation
          }
        });
      }
    },
   
  },// methods{}
  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  cursor:pointer;
}
.avatar-container{
  text-align:center;
}
.avatar-span{
  position: relative;
  display: inline-block;
}
.remove-avatar{
  position:absolute;
  top:10px;
  left:10px;
  cursor:pointer;
}

.disabled-fold{
  opacity:.6;
}
.www{
  color:#707070;
}

</style>
